module.exports = __webpack_public_path__ + "static/media/user-alt-1-svgrepo-com.c56e1732.svg";